import type { MouseEventHandler } from 'react';

import { IntrinsicSizeImg } from 'components/Img';
import Link from 'components/Link';
import { PRODUCT_DETAILS_TECHNICAL_ATTRIBUTES_ID } from 'constants/ids';
import { cn } from 'utils/classNames';
import { useI18n } from 'utils/i18n';

interface Props {
	className?: string;
	energySymbolAlt?: string;
	energySymbolSrc?: string;
	href: string;
	onLinkClick?: MouseEventHandler<HTMLAnchorElement>;
	productSheetLink?: string;
	productSheetLinkDescription?: string;
}

/** Energy symbol and/or product sheet link. */
export default function ProductCardTechnicalInfo({
	className,
	energySymbolAlt,
	energySymbolSrc,
	href,
	onLinkClick,
	productSheetLink,
	productSheetLinkDescription,
}: Props) {
	const { t } = useI18n();

	if (!energySymbolSrc && !productSheetLink) {
		return null;
	}

	return (
		<div className={cn('flex items-center gap-3 text-xs', className)}>
			{energySymbolSrc && (
				<Link
					href={`${href}#${PRODUCT_DETAILS_TECHNICAL_ATTRIBUTES_ID}`}
					onClick={onLinkClick}
					className="hover:opacity-80"
				>
					<IntrinsicSizeImg
						src={energySymbolSrc}
						alt={
							energySymbolAlt ||
							t('product_details_technical_specification_heading')
						}
						className="h-6 object-contain"
					/>
				</Link>
			)}
			{productSheetLink && (
				<Link
					href={productSheetLink}
					target="_blank"
					rel="nofollow"
					underline
					hasExpandedHitArea
				>
					{productSheetLinkDescription ||
						t('product_details_product_sheet_button')}
				</Link>
			)}
		</div>
	);
}
ProductCardTechnicalInfo.displayName = 'ProductCardTechnicalInfo';
